import React, { useMemo } from "react"
import Slider, { Settings } from "react-slick"
import styled, { css } from "styled-components"

import { Color } from "~/consts/style-mixins"

interface Props {
  children: React.ReactNode | React.ReactNode[]
  className?: string
  settings?: Settings
}

interface StyledProps {
  active: boolean
}

const defaultSettings = {
  arrows: false,
  dots: true,
  infinite: true,
  swipeToSlide: true,
  autoplay: true,
  autoplaySpeed: 3000,
}

const { useState } = React

const Carousel = ({ children, className, settings = {} }: Props) => {
  const [activeSlide, ChangeActiveSlide] = useState(0)
  const sliderSettings = useMemo(() => ({ ...defaultSettings, ...settings }), [settings])

  return (
    <StyledCarouselWrapper className={className}>
      <Slider
        {...sliderSettings}
        afterChange={(current) => {
          ChangeActiveSlide(current)
        }}
        customPaging={(i: number) => {
          return <StyledDot active={i === activeSlide} />
        }}
      >
        {Array.isArray(children)
          ? children.map((child) => {
              return child
            })
          : children}
      </Slider>
    </StyledCarouselWrapper>
  )
}

const StyledCarouselWrapper = styled.div`
  width: 100%;
`

const StyledDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  ${({ active }: StyledProps) => css`
    background-color: ${active ? Color.Primary : Color.BorderGray};
  `}
`

export default Carousel
